import {
  Bbc,
  Christies,
  DowJones,
  EnglishHeritage,
  Greepeace,
  Honda,
  ManchesterCity,
  Nature,
  Nikkei,
  OxfordUni,
  Penguin,
  SaveTheChildren,
  TripAdvisor,
  Unicef,
} from "../SVGLogos";
import * as styles from "./LogosSection.module.scss";
import cx from "classnames";
import * as React from "react";

/**
 * 
 * @returns WHY ARE WE USING inline SVGs?
 * because we can't use gatsby-image for SVGs without the quality being badly impacted
// https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-plugin-image/#formats
*/
const FirstRow = (): JSX.Element => {
  return (
    <>
      <Christies className={`${cx(styles.svgStyles, styles.christies)}`} />
      <Bbc className={cx(styles.svgStyles, styles.bbc)} />
      <Nature className={cx(styles.svgStyles, styles.nature)} />
      <Penguin className={cx(styles.svgStyles, styles.penguin)} />
      <Honda className={cx(styles.svgStyles, styles.honda)} />
      <TripAdvisor className={cx(styles.svgStyles, styles.tripAdvisor)} />
      <SaveTheChildren className={cx(styles.svgStyles, styles.saveTheChildren)} />
    </>
  );
};

const SecondRow = (): JSX.Element => {
  return (
    <>
      <DowJones className={cx(styles.svgStyles, styles.dowJones)} />
      <ManchesterCity className={cx(styles.svgStyles, styles.manchesterCity)} />
      <Greepeace className={cx(styles.svgStyles, styles.greenPeace)} />
      <EnglishHeritage className={cx(styles.svgStyles, styles.englishHeritage)} />
      <Unicef className={cx(styles.svgStyles, styles.unicef)} />
      <OxfordUni className={cx(styles.svgStyles, styles.oxfordUni)} />
      <Nikkei className={cx(styles.svgStyles, styles.nikkei)} />
    </>
  );
};

const MobileLogos = (): JSX.Element => {
  return (
    <>
      <Honda className={cx(styles.svgStyles, styles.honda)} />
      <Bbc className={cx(styles.svgStyles, styles.bbc)} />
      <DowJones className={cx(styles.svgStyles, styles.dowJones)} />
      <Christies className={cx(styles.svgStyles, styles.christies)} />
      <TripAdvisor className={cx(styles.svgStyles, styles.tripAdvisor)} />
      <Nature className={cx(styles.svgStyles, styles.nature)} />
      <Unicef className={cx(styles.svgStyles, styles.unicef)} />
      <EnglishHeritage className={cx(styles.svgStyles, styles.englishHeritage)} />
    </>
  );
};
/**
 * LogosSection component displays a section of logos with an optional heading.
 * It renders two rows of logos, each containing several SVG logos.
 * Used on desktop and mobile views.
 *
 * @param {Object} props - The component props.
 * @param {string} [props.heading] - Optional heading for the section.
 * @param {string} [props.customStyling] - Optional styling.
 * @returns {JSX.Element} The rendered LogosSection component.
 */
interface LogosSectionProps {
  heading?: string;
  customStyling?: keyof typeof styles;
}

export const LogosSection = ({ heading, customStyling }: LogosSectionProps): JSX.Element => {
  const customHeadingClass = customStyling ? styles[customStyling] : undefined;

  return (
    <>
      {heading && <p className={cx(styles.logosParagraph, customHeadingClass)}>{heading}</p>}
      {/* mobile layout */}
      <div className={styles.colStyles}>
        <MobileLogos />
      </div>
      <div className={styles.desktopWrapper}>
        <div className={styles.desktopFirstRow}>
          <FirstRow />
        </div>
        <div className={styles.desktopSecondRow}>
          <SecondRow />
        </div>
      </div>
    </>
  );
};
